import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class KycService {
  apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient
  ) { }

  public getKycByStatus(status: string, pagination: any, searchText?: string, paginated = false): Observable<any> {
    let params = new HttpParams()
      .set('status', status)
      .set('page', pagination.page)
      .set('take', pagination.take)

    if (paginated) params = params.set('paginated', 'true');
    if (pagination.sortBy) params = params.set('sortBy', pagination.sortBy);
    if (pagination.sortDirection) params = params.set('sortDirection', pagination.sortDirection);
    if (searchText) {
      params = params.set('searchText', searchText);
    }
    
    return this.http.get<any>(`${this.apiUrl}/user-kyc/get-by-status`, { params });
  }

  getPendingCounts() {
    return this.http.get<{ verifications: number; purchases: number; withdrawals: number }>(`${this.apiUrl}/user-kyc/pending-counts`);
  }

  updateUserDocumentation(id: string, data: any) {
    // let user = JSON.parse(localStorage.getItem('user')!);
    return this.http.put<any>(`${this.apiUrl}/user-kyc/update-user-documentation/${ id }`, data);
  }
}
